<template>
  <v-chip
    close
    outlined
    @click.stop
    @click:close="$emit('remove', true)"
    @mousedown.stop>
    <v-text-field
      v-model="searchVal"
      :placeholder="name"
      color="black"
      class="pt-0 mt-0 search-filter__textfield"
      :size="textFieldSize"
      hide-details
      persistent-placeholder
      @input="$emit('update', { value: searchVal })" />
  </v-chip>
</template>
<script>
export default {
  name: 'SearchFilterInputText',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    itemValue: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    searchVal: '',
  }),
  computed: {
    textFieldSize() {
      // Can remove and use field-sizing once it's more widely supported.
      // = https://developer.mozilla.org/en-US/docs/Web/CSS/field-sizing
      // Using the size according to text length exactly doesn't work, so...we have this weird function.
      // which I conjured arbitrarily eyeballing. I think it has to do with the flex behavior of the chips + input.
      return this.searchVal?.length ? Math.round(Number(this.searchVal.length) * 1.15) : 5;
    },
  },
  watch: {
    itemValue: {
      handler() {
        this.searchVal = this.itemValue;
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.searchVal = '';
  },
};
</script>
